const ru = {
  task: {
    center: "Центр задач",
    callTask: "Вызов задачи",
    giftTask: "Подарочное задание",
    liveTask: "Задача новичка",
    sevenTask: "7-дневное задание",
    callMessage: "Позвоните еще, чтобы получить награды",
    giftMessage: "Получайте подарки, чтобы получать награды",
    liveMessage: "Увеличьте продолжительность действия Live, чтобы получить вознаграждение в размере {d}.",
    sevenMessage: "Выполняйте ежедневные задания, чтобы получить награду в размере {d}.",
    cellTitle: "Звоните ≥{d} минут (раз):",
    reward: "Награда",
    lastWeek: "Награда прошлой недели:",
    weekGift: "Еженедельный доход от подарков:",
    RewardDescription: "Инструкции по вознаграждению",
    everyWeekGift: "Еженедельный доход от подарков <span class='web'>(Bonus)</span>",
    endTask: 'Задача окончена',
    query: 'ОК'
  },
  message: {
    taxt1: "1. Каждый расчетный цикл длится с понедельника по воскресенье. Чем больше продолжительность видеозвонка ≥{d} минут, тем щедрее вознаграждение.",
    taxt2: "2. Вы можете получать награды только одного уровня в неделю, исходя из оценки времени продолжительности вашего единственного звонка на этой неделе ≥{d} минут.",
    taxt3: "3. После официальной проверки награды будут начислены на ваш аккаунт до в следующий четверг после урегулирования.",
    taxt4: "4. Если будет обнаружено мошенничество, вы будете дисквалифицированы для получения любого вознаграждения.",
    taxt5: "5. Если у вас есть какие-либо вопросы, обратитесь по адресу：<span class='web'>support@honeycamweb.com</span>",
    hint: "Примечания: в зависимости от международного времени",
    rewardOne1: "1.В течение 7 дней после запуска задачи",
    rewardOne2: "1) Live≥2 часов и скорость завершения вызова ≥{d} в день в течение как минимум 6 дней;",
    rewardOne3: "2) В течение 7 дней после запуска задания общий доход достигает ≥{d} Bonus;",
    rewardOne4: "3) Если вышеуказанные условия выполняются одновременно, вы можете получить вознаграждение в размере <span style='color: #ff2794'>{d}</span> от платформы после завершения задачи;",
    rewardOne5: "2.Якорь может вознаграждать не более одной учетной записи, а несколько учетных записей недействительны;",
    rewardOne6: "3.При обнаружении читерства квалификация на вознаграждение будет аннулирована;",
    rewardOne7: "4.Пользователь, выполнивший задачу после ее завершения. Подпишитесь на официальную домашнюю страницу <span class='web' style='color: #f99634'>Facebook \"Honeycam\"</span> и добавьте группу, чтобы получить вознаграждение в размере <span style='color: #ff2794'>$10</span>;",
    rewardOne8: "5.Если у вас есть какие-либо вопросы, обратитесь по адресу：<span class='web'>support@honeycamweb.com;</span>",
    rewardTwo1: "Пользователи, которые зарабатывают более {d} в день во время миссии, получат возможность на следующий день занять верхнюю позицию среди рекомендуемых или популярных страниц, чтобы получить больше внимания;"
  },
  gift: {
    test1: "1. Расчетный цикл с понедельника по воскресенье. Чем больше подарков вы получите, тем щедрее награды.",
    test2: "2. Вы можете получать награды только за один уровень каждую неделю, и уровень оценивается на основе общего дохода за эту неделю.",
    test3: "3. После официальной проверки награда будет переведена на ваш счет доходов до следующего четверга.",
    test4: "4. Если будет обнаружено мошенничество, вы будете дисквалифицированы для получения любого вознаграждения.",
    test5: "5. Если у вас есть какие-либо вопросы, обратитесь по адресу：<span class='web'>support@honeycamweb.com</span>",
    giftNum: "Получено подарков ≥{d}",
    totalBonus: "Доход ≥{d}Bonus",
    liveCallTime: "<span class='web'>live</span>≥{d}(m)",
    callTime: "Звоните ≥{d}(m)",
    callRate: "接通率≥{d}%"
  },
  new: {
    rewardOne: "Награда первая",
    rewardTwo: "Награда вторая",
    start: "Официальное открытие задачи сегодня в 0:00",
    hint: "Держите Live≥{d} часов, а скорость завершения вызова ≥{d} в день.Вы можете получить вознаграждение в размере {d}.",
    tastReward: "Общий доход <span class='web'>Bonus</span> во время миссии",
    liveTime: "Продолжительность Live сегодня",
    callRate: "Уровень завершенности звонка на сегодня",
    progress: "Прогресс задачи",
    endRate: "(цель ≥",
    overText1: "Поздравляю с выполнением задания",
    overText2: "Подпишитесь на официальный <span class='web'>Facebook \"Honeycam\"</span> и добавьте группу, чтобы получить вознаграждение в размере {d}.",
    overText3: "Жалко, что задание не выполнено и вы не можете получить награду в {d}.",
    overText4: "Подпишитесь на официальный <span class='web'>Facebook \"Honeycam\"</span>, чтобы получить больше информации о задаче.",
    openfb: " Откройте <span class='web'>Facebook</span>",
  },
  week: {
    live30: "Завтра Live≥{d} минут",
    call5: "Завтра звонок ≥5 минут",
    rewardHint: "(Если все следующие задания будут выполнены, <span style='color: #ff2794'>вы получите дополнительную награду в размере <span class='web'>$20</span></span>)",
    newLive: "Сегодняшний Live",
    newLiveSec: "(цель ≥{d})",
    newCall: "Сегодняшний звонок",
    newCallRate: "Уровень завершенности звонка на сегодня",
    newBonus: "Сегодняшний доход Bonus ",
    newGift: "Сегодняшнее количество подарков",
    newReward: "Сегодняшние награды",
    days: "День",
    taskReq: "Требования к задаче",
    task1: "1.Задания на каждый день рассчитываются в 0:00, а выдаются на ваш счет Bonus в 0:00;",
    task2: "2.Если задача не будет выполнена в этот день, она не удастся. Неудачная задача не может быть возобновлена;",
    task3: "3.Выполнены только все 7-дневные задания, можно получить премиальный пакет в размере {d};",
    task4: "4.Якорь может вознаграждать не более одной учетной записи, а несколько учетных записей недействительны;",
    task5: "5.Если будет обнаружен обман, квалификация на награды будет отменена;",
    task6: "6.Пользователь, выполнивший задачу после ее завершения. Подпишитесь на официальную домашнюю страницу<span class='web' style='color: #f99634'>Facebook \"Honeycam\"</span> и добавьте группу, чтобы получить вознаграждение в размере <span style='color: #ff2794' class='web'>$20</span>;",
    task7: "7.Если у вас есть какие-либо вопросы, обратитесь по адресу：<span class='web'>support@honeycamweb.com;</span>",
  }
};

export default ru;
